module.exports = __webpack_public_path__ + "img/daniMx2.0b4e8600.jpg";